// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

const appId = process.env.REACT_APP_CONFIG_APP_ID;
const authority = process.env.REACT_APP_CONFIG_AUTHORITY;

const config = {
  appId: appId,
  authority: `https://login.microsoftonline.com/${authority}`,
  redirectUri: window.location.origin,
  scopes: [
    'user.read',
    'mailboxsettings.read',
  ]
};

export default config;
